import axios from 'axios'

const baseURL = process.env.API_URL_CMS

const api = axios.create({
  baseURL,
})

export default api
